import React, { useEffect } from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import ProcessHero from './components/ProcessHero';
import ProcessSteps from './components/ProcessSteps';
import MaterialsShowcase from './components/MaterialsShowcase';
import QualityControl from './components/QualityControl';
import ArtisanProfiles from './components/ArtisanProfiles';
import ProcessCTA from './components/ProcessCTA';

const ArtisanalProcess = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "Processo Artesanal de Criação de Móveis",
    "description": "Conheça nosso processo artesanal completo: da seleção da madeira premium ao acabamento final.",
    "url": "https://phmoveis.com.br/artisanal-process",
    "image": "https://phmoveis.com.br/assets/process-og.jpg",
    "totalTime": "P45D",
    "supply": [
      {
        "@type": "HowToSupply",
        "name": "Madeira Nobre Brasileira"
      },
      {
        "@type": "HowToSupply", 
        "name": "Ferramentas Artesanais"
      },
      {
        "@type": "HowToSupply",
        "name": "Acabamentos Premium"
      }
    ],
    "step": [
      {
        "@type": "HowToStep",
        "name": "Seleção da Madeira",
        "text": "Selecionamos cuidadosamente madeiras nobres brasileiras certificadas"
      },
      {
        "@type": "HowToStep", 
        "name": "Projeto e Desenho",
        "text": "Criamos projetos únicos baseados nas necessidades do cliente"
      },
      {
        "@type": "HowToStep",
        "name": "Corte e Preparação",
        "text": "Cortamos e preparamos a madeira seguindo técnicas tradicionais"
      },
      {
        "@type": "HowToStep",
        "name": "Montagem Artesanal",
        "text": "Montamos cada peça com técnicas de marcenaria tradicional"
      },
      {
        "@type": "HowToStep",
        "name": "Acabamento Final",
        "text": "Aplicamos acabamentos premium para realçar a beleza natural da madeira"
      }
    ]
  };

  return (
    <>
      <SEO
        title="Processo Artesanal | Tradição e Excelência em Marcenaria"
        description="Conheça nosso processo artesanal completo: da seleção da madeira premium ao acabamento final. Artesãos especializados, técnicas tradicionais e qualidade garantida."
        keywords="processo artesanal, móveis artesanais, marcenaria, madeira premium, artesãos, qualidade, sustentabilidade, técnicas tradicionais, madeira certificada"
        image="https://phmoveis.com.br/assets/process-og.jpg"
        url="https://phmoveis.com.br/artisanal-process"
        type="website"
        structuredData={structuredData}
      />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <ProcessHero />
          <ProcessSteps />
          <MaterialsShowcase />
          <QualityControl />
          <ProcessCTA />
        </main>
      </div>
    </>
  );
};

export default ArtisanalProcess;